import React from "react";
import ConfigurationAvancee from "../../ConfigrationAdvanced/ConfigurationAvancee";

function ConfigurationavancePage() {
  return <ConfigurationAvancee />;
}

export default ConfigurationavancePage;
